var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"wrapper-base-card"},[_vm._t("icon"),_c('h3',[_vm._t("heading")],2),_c('img',{staticClass:"break-line",attrs:{"src":require("../assets/images/break-line.svg"),"alt":""}}),_c('p',[_vm._t("text")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }